import React, { useState } from "react";
import { Link } from "react-router-dom";
import CustomerHeader from "../components/CustomerHeader";
import CustomerFooter from "../components/CustomerFooter";

function HelpCenter() {
  const [isMobile] = useState(window.innerWidth <= 768);

  return (
    <>
      <CustomerHeader />
      <div
        style={{
          padding: isMobile ? "86px 16px 30px" : "106px 32px 42px",
          background: "#f9fafb",
        }}
      >
        <div
          style={{
            maxWidth: "980px",
            margin: "0 auto",
            background: "white",
            borderRadius: "16px",
            padding: isMobile ? "24px" : "40px",
            border: "1px solid #e5e7eb",
          }}
        >
          <h1 style={{ marginTop: 0, color: "#111827" }}>Help Center</h1>
          <p style={{ color: "#4b5563", lineHeight: "1.7", fontSize: "15px" }}>
            Find quick answers and support options for booking, payments, account
            access, business onboarding, and freelancer setup.
          </p>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
              gap: "16px",
              marginTop: "24px",
            }}
          >
            <div style={{ padding: "18px", background: "#f3f4f6", borderRadius: "12px" }}>
              <h3 style={{ marginTop: 0, color: "#111827" }}>Bookings</h3>
              <p style={{ margin: 0, color: "#6b7280", fontSize: "14px" }}>
                Creating, managing, and canceling appointments.
              </p>
            </div>
            <div style={{ padding: "18px", background: "#f3f4f6", borderRadius: "12px" }}>
              <h3 style={{ marginTop: 0, color: "#111827" }}>Payments</h3>
              <p style={{ margin: 0, color: "#6b7280", fontSize: "14px" }}>
                Card payments, payouts, invoices, and refunds.
              </p>
            </div>
            <div style={{ padding: "18px", background: "#f3f4f6", borderRadius: "12px" }}>
              <h3 style={{ marginTop: 0, color: "#111827" }}>Accounts</h3>
              <p style={{ margin: 0, color: "#6b7280", fontSize: "14px" }}>
                Login issues, verification, and profile settings.
              </p>
            </div>
          </div>

          <div style={{ marginTop: "22px", display: "grid", gap: "14px" }}>
            <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "12px", padding: "16px" }}>
              <h3 style={{ margin: "0 0 8px", color: "#111827" }}>Getting Started</h3>
              <p style={{ margin: 0, color: "#4b5563", lineHeight: "1.7", fontSize: "14px" }}>
                Customers can browse and book. Businesses can register through
                For Businesses, and independent providers can start through the
                Freelancer path.
              </p>
            </div>
            <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "12px", padding: "16px" }}>
              <h3 style={{ margin: "0 0 8px", color: "#111827" }}>Account Types</h3>
              <p style={{ margin: 0, color: "#4b5563", lineHeight: "1.7", fontSize: "14px" }}>
                Business accounts are for licensed businesses managing teams or
                locations. Freelancer accounts are for independent professionals
                building their own brand and client base.
              </p>
            </div>
            <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "12px", padding: "16px" }}>
              <h3 style={{ margin: "0 0 8px", color: "#111827" }}>Booking and Payments</h3>
              <p style={{ margin: 0, color: "#4b5563", lineHeight: "1.7", fontSize: "14px" }}>
                Booking details, prices, and service information are shown before
                checkout. Payment processing and payout timelines can vary by
                account setup and provider processing windows.
              </p>
            </div>
          </div>

          <p style={{ marginTop: "24px", color: "#6b7280" }}>
            Need more help? Visit <Link to="/faq">FAQ</Link> or <Link to="/contact">Contact</Link>.
          </p>
        </div>
      </div>
      <CustomerFooter />
    </>
  );
}

export default HelpCenter;
